"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import 'polyfill';
// global.Promise = require('es6-promise').Promise;
// import 'picturefill';
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
// import Linker from 'linker';
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
require("@fancyapps/fancybox");
require("fancy-defaults");
var page2top_1 = __importDefault(require("page2top"));
var object_fit_images_1 = __importDefault(require("object-fit-images"));
var tab_1 = __importDefault(require("tab"));
var menu_1 = __importDefault(require("menu"));
var top_1 = __importDefault(require("top"));
var local_1 = __importDefault(require("local"));
var product_1 = require("product");
require("accordion");
var form_1 = __importDefault(require("form"));
require("swipe-elem");
var agree_cookie_1 = __importDefault(require("agree-cookie"));
(0, hasher_1.default)();
$(function () {
    new page2top_1.default();
    // new Linker({
    // 	extendLink: '.sw-ExtendLink'
    // });
    // new Header();
    new menu_1.default();
    new local_1.default();
    new product_1.ProductSlider();
    (0, product_1.SpecTable)();
    (0, tel_handler_1.default)();
    (0, slide_scroll_1.default)({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll, .sw-Modal'
    });
    $('.sw-Modal').fancybox();
    $('.c-Acod').accordion();
    $(window).on('viewportChanged', function () {
        if (util.viewport === 'phone') {
            $('.prod-Slider_Inner').slick('init');
        }
        ;
    });
    $('.sw-Scroll').swipeElem({
        width: 800
    });
    new tab_1.default();
    // $('.c-Grid.-col-2').fitHeight({
    // 	target: [],
    // 	column: 2,
    // 	responsive: {
    // 		largeDesktop: 2,
    // 		desktop: 2,
    // 		tablet: 2,
    // 		phone: 1
    // 	}
    // })
    new top_1.default();
    new form_1.default();
    $('.f-Form').not('#contactForm').on('submit', function (e) {
        if ($('.send.-disabled').length) {
            e.preventDefault();
            $('.f-Error.-recaptcha').show(0);
        }
        ;
    });
    new agree_cookie_1.default();
    (0, object_fit_images_1.default)('img.sw-ObjectFit', { watchMQ: true });
});
